import React from 'react';
import { Link, Route, Routes } from 'react-router-dom';

import managerMenuBackgroundSrc from '../Honored_Blue_Nebula.png';
import BottomMenu from '../BottomMenu';
import GroupMenu from '../GroupMenu';
import PlayerProfile from '../../PlayerManagement/Profile';
import { ASSETS_URL, LOGO_URL } from '../../../Settings';
import { QuickRouter } from '../../TwoD/QuickRouter';

import MainMenu from './MainMenu';

import '../manager-menu.css';


/**
 * CC_MAIN_MENU (2026-05-27).
 *
 * Replaces ManagerMenu as the `'*'` route shell. Hoists the load-
 * bearing pieces ManagerMenu used to mount (background video,
 * GroupMenu, BottomMenu, PlayerProfile, QuickRouter, and the
 * first-time group fetch) and routes the inner viewport to MainMenu
 * by default, Lobby at `/casual`. The Play/Wiki/Forum TopMenu and
 * the PlaySubMenu Casual/Existing/Single tabs are no longer rendered
 * — the surrounding files stay per no-blind-deletes.
 *
 * CC_DISCORD_LOBBY_BULLETPROOF (2026-05-31, invariant I4): the Main
 * Menu is the canonical "not in a lobby" surface and no longer probes
 * the backend for group membership on mount. The old
 * `firstTimeGroupFetch()` here sent a Group/Members on every Main Menu
 * mount — the frontend half of the "every connected user must be in a
 * lobby" assumption that paired with the dispatcher auto-create to mint
 * invisible solo lobbies. With the backend auto-create gone, that probe
 * is both unnecessary and wrong: the user holds no lobby until they
 * explicitly create one (New Game) or join one (a Live tile / rejoin),
 * and those explicit paths broadcast Members themselves. Lobby.js
 * hydrates off that broadcast (and off `discord-lobby-joined`), so it no
 * longer needs a mount-time probe — and a Members probe with no lobby
 * is now a harmless backend no-op anyway.
 *
 * CC_FE_PAGES (2026-06-01): the inner `casual` → <Lobby> route is gone.
 * The Lobby surface now lives at `/game/:lobbyUuid` (GamePage), and the
 * LiveTile grid moved to `/lobbies` (LobbiesPage). This shell is purely
 * the Main Menu surface now — every inner path renders <MainMenu>.
 */
export default function MainMenuShell({ app }) {
    const videoSrc = `${ASSETS_URL}video/HomeScreen_v002.mp4`;
    return (
        <>
            <div className={'manager-menu-background'}>
                <video width="100%" loop autoPlay muted playsInline
                       disableRemotePlayback={true}
                       poster={managerMenuBackgroundSrc}
                       className={'manager-menu-background-video'}>
                    <source src={videoSrc} type="video/mp4" />
                </video>
            </div>
            <div id={'manager-menu'} className={'manager-menu'}>
                <QuickRouter />
                <div id={'top-container'}
                     className={'d-flex flex-wrap'}>
                    <div className={'manager-menu-top-anchor'}>
                        <div className={'manager-menu-top-container'}>
                            <div className={'manager-menu-top-items '}>
                                <Link to={'/'}
                                      className={'manager-menu-top-item-link'}>
                                    <img
                                        className={'manager-menu-top-logo'}
                                        src={LOGO_URL}
                                        alt={'logo'}
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <GroupMenu app={app} />
                </div>
                <Routes>
                    <Route index
                           element={<MainMenu app={app} />} />
                    <Route path="*"
                           element={<MainMenu app={app} />} />
                </Routes>
                <BottomMenu app={app} />
                <PlayerProfile app={app} />
            </div>
        </>
    );
}
